// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"4cbc9e80","513":"4d22b401","703":"af0003c0"}[chunkId] + ".chunk.js";
};